module.exports = __webpack_public_path__ + "img/cheese.b59ab0cd.jpg";